var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizes, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var viewType = {
    insurersView: [
        {
            active: true,
            icon: {
                icon: icons.GridView,
            },
            id: "1",
            name: "CardView",
        },
        {
            active: false,
            icon: {
                icon: icons.List,
            },
            id: "2",
            name: "List",
        },
        {
            active: false,
            icon: {
                icon: icons.BlurLinear,
            },
            id: "3",
            name: "GridView",
        },
    ],
    title: "Administrar usuarios",
    titleColor: "#3A56A1",
};
export var AdminUsersDTO = {
    viewTypeProps: viewType,
    paginationProps: {
        count: 100,
        labelRowsPerPage: "Filas por página",
        pagePagination: 0,
        rowsPerPageOptions: [19, 35, 50],
        rowsPerPages: 0,
        showFirstButton: true,
        showLastButton: true,
    },
    drawerProps: {
        BgBackdrop: "rgb(0 0 0 / 69%)",
        BgcCloseButton: "#FFFFFF",
        bgColorDrawer: " #FFFFFF",
        colorIcon: "#3A56A1",
        openDrawer: false,
        showButton: true,
        title: "Roles de usuario",
        titleButton: "",
        view: 1,
    },
    cardsDataProps: {
        id: "",
        backgroundColor: "#FFFFFF",
        height: "136px",
        heightList: "68px",
        isList: false,
        menuItem: [
            {
                disabled: false,
                icon: {
                    color: "#006ac6",
                    icon: icons.Edit,
                    size: sizesIcon.standard,
                },
                id: "1",
                name: "Modificar",
            },
            {
                disabled: false,
                icon: {
                    color: "#006ac6",
                    icon: icons.Visibility,
                    size: sizesIcon.standard,
                },
                id: "2",
                name: "Ver Roles",
            },
            // {
            //   disabled: false,
            //   icon: {
            //     color: "#006ac6",
            //     icon: icons.DeleteForever,
            //     size: sizesIcon.standard,
            //   },
            //   id: "3",
            //   name: "Eliminar",
            // },
        ],
    },
    cardAddNewProps: {
        backgroundColor: "#FFFFFF",
        height: 136,
        heightList: 68,
        icon: icons.AddCircle,
        iconColor: "#3A56A1",
        title: "Crear usuario",
    },
    buttonAddProps: {
        label: "Crear usuario",
        size: sizes.large,
        variant: variants.contained,
    },
    tableProps: {
        columnHeaderHeight: 32,
        height: "300px",
        rowHeight: 35,
        width: "100%",
        columns: [
            {
                field: "rolName",
                headerName: "Nombre Rol",
                width: 250,
                flex: 1,
            },
            {
                field: "description",
                headerName: "Descripción",
                width: 250,
                flex: 1,
            },
            // {
            //   field: "permits",
            //   flex: 1,
            //   headerName: "Permisos",
            // },
        ],
        rows: [],
        multipleSelection: false,
    },
    filterReportProps: {
        filters: [
            {
                active: true,
                backgroundColor: "#E8EEFF",
                border: true,
                borderRadius: "8px",
                borderType: "1px solid #96ABFF",
                color: "#0D1BD9",
                id: "fullTextSearch",
                sizes: "40px",
                type: "fullTextSearch",
            },
            {
                label: "Limpiar Filtros",
                type: "cleanButton",
                variantButtons: variants.text,
                visible: true,
            },
            // {
            //   id: "users",
            //   titleFilter: "",
            //   type: "dropdownMultiple",
            //   titleSearch: "buscar",
            //   allCheckedTitle: "Todos los Usuarios",
            //   allChecked: false,
            //   border: true,
            //   borderRadius: "8px",
            //   colorTitleFilter: "#0D0D0D",
            //   dropdownIndex: 1,
            //   isOneSelection: false,
            //   label: "Usuarios",
            //   listDropDown: [
            //     {
            //       active: false,
            //       id: "false",
            //       name: "Activos",
            //       value: "false",
            //     },
            //     {
            //       active: false,
            //       id: "true",
            //       name: "Eliminados",
            //       value: "true",
            //     },
            //   ],
            // },
            {
                id: "deleted",
                type: "dropdownMultiple",
                label: "Seleccione una opción",
                titleFilter: "Estado",
                titleSearch: "buscar",
                allCheckedTitle: "Todos los estados",
                allChecked: false,
                border: true,
                borderRadius: "8px",
                colorTitleFilter: "#0D0D0D",
                dropdownIndex: 2,
                isOneSelection: true,
                listDropDown: [
                    {
                        id: "false",
                        name: "Activos",
                        active: false,
                        value: "false",
                    },
                    {
                        id: "true",
                        name: "Eliminados",
                        active: false,
                        value: "true",
                    },
                ],
            },
            {
                id: "hasRole",
                type: "dropdownMultiple",
                label: "Seleccione una opción",
                titleFilter: "Rol Asignado",
                titleSearch: "buscar",
                allCheckedTitle: "Todos los estados",
                allChecked: false,
                border: true,
                borderRadius: "8px",
                colorTitleFilter: "#0D0D0D",
                dropdownIndex: 3,
                isOneSelection: true,
                listDropDown: [
                    {
                        id: "true",
                        name: "Con rol",
                        active: false,
                        value: "true",
                    },
                    {
                        id: "false",
                        name: "Sin rol",
                        active: false,
                        value: "false",
                    },
                ],
            },
        ],
    },
    viewGridProps: function (onOptionsCardClick) { return ({
        width: "100%",
        height: "100%",
        columnHeaderHeight: 32,
        rowHeight: 35,
        hideFooterPagination: true,
        pageSize: 19,
        hidePagination: true,
        columns: [
            {
                field: "type",
                headerName: "Acciones",
                width: 75,
                renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, disableRipple: true, iconColor: "#3A56A1", menuItem: [
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Edit,
                                    size: sizesIcon.standard,
                                },
                                id: "1",
                                name: "Modificar",
                            },
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Visibility,
                                    size: sizesIcon.standard,
                                },
                                id: "2",
                                name: "Ver Roles",
                            },
                        ], onClickContextMenu: function (opt) {
                            return onOptionsCardClick === null || onOptionsCardClick === void 0 ? void 0 : onOptionsCardClick(opt, params.row);
                        }, sizeIcon: sizesIcon.smallXl }) }))); },
            },
            {
                field: "names",
                headerName: "Nombres",
                // width: 250,
                flex: 1,
            },
            {
                field: "lastNames",
                headerName: "Apellidos",
                // width: 250,
                flex: 1,
            },
            {
                field: "email",
                headerName: "Correo",
                // width: 250,
                flex: 1,
            },
            {
                field: "userName",
                headerName: "Nombre de usuario",
                // width: 250,
                flex: 1,
            },
            {
                field: "createdAt",
                headerName: "Creado el",
                width: 150,
            },
            {
                field: "enabled",
                headerName: "Estado",
                width: 150,
            },
        ],
        rows: [],
    }); },
};
export var DataFormUsers = {
    idType: "",
    documentNumber: "",
    names: "",
    lastNames: "",
    birthday: "",
    gender: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    company: "",
    branch: "",
};
export var ModalUiProps = {
    title: "",
    name: "",
    openModal: false,
    onClose: function () { },
    minWidthModal: "1000px",
    minHeightModal: "440px",
    backgroundColor: "#E8E8E8",
    closeModalOutside: true,
    showButtons: false,
    buttonAdd: {
        label: "Asignar",
        variant: variants.contained,
    },
    buttonCancel: {
        label: "Cancelar",
        variant: variants.outlined,
    },
};
export var AddRolesToUser = {
    mode: "roles",
    assignedTitle: "Roles Asignados",
    availableTitle: "Roles Disponibles",
    searchPlaceholder: "Buscar Rol",
    assignedItems: [],
    availableItems: [],
};
